import React, { useState, useCallback, useEffect } from 'react';
import { useAuthInfo } from '../../../lib/jwt';
import { toast } from 'react-toastify';
import { useRouter } from 'next/router';
import { Chain } from '../../../lib/getGraphqlClient';
import logCustomEvent from '../../../helpers/analytics';

type UserFollowing = {
  follower_uid: number;
  id: number;
  following_uid: number;
};

export default function FollowButton({ user, onUpdateFollowersCount }) {
  const [followed, setFollowed] = useState(false);
  const [authInfo, token] = useAuthInfo(false);
  const router = useRouter();
  const [userFollow, setUserFollow] = useState<UserFollowing[]>([]);

  useEffect(() => {
    if (user) {
      Chain()
        .query({
          voyce_users_followers: [
            {
              where: {
                follower_uid: { _eq: authInfo?.id ?? 0 },
                following_uid: { _eq: user.id }
              }
            },
            {
              follower_uid: true,
              id: true,
              following_uid: true
            }
          ]
        })
        .then(res => setUserFollow(res.voyce_users_followers));
    }
  }, [user]);

  useEffect(() => {
    if (userFollow.length !== 0) {
      setFollowed(true);
    } else {
      setFollowed(false);
    }
  }, [userFollow]);

  const onFollowClick = useCallback(
    (userId: number, followingId: number) => {
      if (userId === undefined) {
        router.push('/login');
        return;
      }
      if (followed === true) {
        fetch('/api/followers', {
          method: 'DELETE',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            userId,
            followingId
          })
        })
          .then(response => {
            if (response.ok) {
              toast.success('Succcessfully unsubscribed!', {
                position: 'top-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
              });
              onUpdateFollowersCount(followingId, false);
              setFollowed(false);
            }
          })
          .catch(error => console.log(error));
      } else {
        // analytics
        logCustomEvent('CreatorFollow', { creator_id: followingId, user_id: userId });
        fetch('/api/followers', {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            userId,
            followingId
          })
        })
          .then(response => {
            if (response.ok) {
              toast.success('Succcessfully subscribed!', {
                position: 'top-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
              });
              onUpdateFollowersCount(followingId, true);
              setFollowed(true);
            }
          })
          .catch(error => console.log(error));
      }
    },
    [followed]
  );
  return (
    <div>
      <button
        className="text-white hover:bg-red-dark bg-bright-red text text-sm font-bold py-1 px-4 rounded-lg"
        onClick={() => onFollowClick(authInfo?.id, user?.id)}
      >
        {followed ? 'Unfollow' : 'Follow'}
      </button>
    </div>
  );
}
